<template>
  <div>
    <el-container>
      <el-aside
        width="200px"
        style="height: 800px;padding-right:10px;overflow: auto"
        v-if="permissions.indexOf('树') > -1"
      >
        <el-input :size="componentSize" v-model="filter" placeholder="请输入参数"></el-input>
        <el-tree
          :data="treeData"
          :props="defaultProps"
           highlight-current
          :accordion="true"
          :expand-on-click-node="false"
          :filter-node-method="nodeFilter"
          @node-click="handleNodeClick"
          :default-expanded-keys="[1]"
          v-loading="treeLoading"
          ref="tree"
          v-if="permissions.indexOf('树') > -1"
        ></el-tree>
      </el-aside>

      <el-main style="padding: 2px;">
        <el-card class="box-card" v-if="permissions.indexOf('列表') > -1">
          <el-form ref="searchForm" :model="searchForm">
            <el-row :gutter="20">
              <el-col :sm="24" :md="12" :lg="6">
                <el-form-item label prop="name">
                  <el-input
                    :size="componentSize"
                    v-model="searchForm.name"
                    placeholder="请输入部门名称"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :md="12" :lg="6">
                <el-form-item label prop="number">
                  <el-input
                    :size="componentSize"
                    v-model="searchForm.number"
                    placeholder="请输入部门编号"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :md="12" :lg="6">
                <el-form-item label prop="address">
                  <el-input
                    :size="componentSize"
                    v-model="searchForm.address"
                    placeholder="请输入部门地址"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="24" :md="12" :lg="6">
                <el-button
                  :size="componentSize"
                  type="primary"
                  @click="pageList"
                  icon="el-icon-search"
                >查询</el-button>
                <el-button
                  :size="componentSize"
                  type="primary"
                  @click="reset"
                  icon="el-icon-refresh"
                >重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <el-card class="box-card" style="margin-top: 20px;">
          <el-row :span="24">
            <el-col :span="12">
              <el-button
                :size="componentSize"
                type="primary"
                @click="addFormVisible = true"
                icon="el-icon-plus"
                v-if="permissions.indexOf('新增') > -1"
              >新增</el-button>
              <el-button
                :size="componentSize"
                type="danger"
                @click="batchDeleteDepartment"
                icon="el-icon-minus"
                v-if="permissions.indexOf('批量删除') > -1"
              >批量删除</el-button>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button
                :size="componentSize"
                type="primary"
                @click="importFormVisible = true"
                icon="el-icon-download"
                v-if="permissions.indexOf('导入') > -1"
              >导入</el-button>
              <el-button
                :size="componentSize"
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                :loading="loading"
                icon="el-icon-upload2"
                v-if="permissions.indexOf('导出') > -1"
              >导出</el-button>
            </el-col>
          </el-row>
          <el-table
            :size="componentSize"
            ref="multipleTable"
            :data="page.rows"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%;"
            border
            v-loading="tableLoading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="parentId" label="父级id"></el-table-column>
            <el-table-column prop="name" label="部门名称"></el-table-column>
            <el-table-column prop="number" label="部门编号"></el-table-column>
            <el-table-column prop="address" label="部门地址"></el-table-column>
            <el-table-column prop="position" label="部门职位"></el-table-column>
            <el-table-column prop="telephone" label="固定电话"></el-table-column>
            <el-table-column prop="fax" label="传真号码"></el-table-column>
            <el-table-column prop="sequence" label="排序"></el-table-column>
            <el-table-column prop="active" label="状态"></el-table-column>
            <el-table-column prop label="操作" width="120" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <span
                    @click="selection = scope.row.id, detailFormVisible = true"
                    v-if="permissions.indexOf('查看') > -1"
                  >
                    <i class="el-icon-view" title="查看"></i>查看
                  </span>
                  <span
                    @click="selection = scope.row.id, editFormVisible = true"
                    v-if="permissions.indexOf('编辑') > -1"
                  >
                    <i class="el-icon-edit" title="编辑"></i>编辑
                  </span>
                  <span @click="deleteDepartment(scope.row)" v-if="permissions.indexOf('删除') > -1">
                    <i class="el-icon-delete" title="删除"></i>删除
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next"
            style="margin-top: 20px;text-align: right;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
            v-if="permissions.indexOf('列表') > -1"
          ></el-pagination>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      :width="addFormDialogWidth"
      left
      v-if="permissions.indexOf('新增') > -1"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
        :inline="addFormInline"
      >
        <el-form-item label="父级id" prop="parentId">
          <el-input
            :size="componentSize"
            type="number"
            v-model="addForm.parentId"
            placeholder="请输入父级id"
            auto-complete="off"
            maxlength="19"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input
            :size="componentSize"
            v-model="addForm.name"
            placeholder="请输入部门名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门编号" prop="number">
          <el-input
            :size="componentSize"
            v-model="addForm.number"
            placeholder="请输入部门编号"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addDepartment">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="detailFormVisible"
      :width="detailFormDialogWidth"
      left
      v-if="permissions.indexOf('查看') > -1"
    >
      <el-form
        ref="detailForm"
        :model="detailForm"
        :label-width="formLabelWidth"
        :rules="detailFormRules"
        :inline="detailFormInline"
      ></el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="detailFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateDepartment">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :width="editFormDialogWidth"
      left
      v-if="permissions.indexOf('编辑') > -1"
    >
      <el-form
        class="edit-form-dialog"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
        :inline="editFormInline"
      >
        <el-form-item label="父级id" prop="parentId">
          <el-input
            :size="componentSize"
            type="number"
            v-model="editForm.parentId"
            placeholder="请输入父级id"
            auto-complete="off"
            maxlength="19"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input
            :size="componentSize"
            v-model="editForm.name"
            placeholder="请输入部门名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门编号" prop="number">
          <el-input
            :size="componentSize"
            v-model="editForm.number"
            placeholder="请输入部门编号"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门地址" prop="address">
          <el-input
            :size="componentSize"
            v-model="editForm.address"
            placeholder="请输入部门地址"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门职位" prop="position">
          <el-input
            :size="componentSize"
            v-model="editForm.position"
            placeholder="请输入部门职位"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="固定电话" prop="telephone">
          <el-input
            :size="componentSize"
            v-model="editForm.telephone"
            placeholder="请输入固定电话"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="传真号码" prop="fax">
          <el-input
            :size="componentSize"
            v-model="editForm.fax"
            placeholder="请输入传真号码"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sequence">
          <el-input
            :size="componentSize"
            type="number"
            v-model="editForm.sequence"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateDepartment">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      v-if="permissions.indexOf('导入') > -1"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="componentSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="parentId" label="父级id"></el-table-column>
        <el-table-column prop="name" label="部门名称"></el-table-column>
        <el-table-column prop="number" label="部门编号"></el-table-column>
        <el-table-column prop="address" label="部门地址"></el-table-column>
        <el-table-column prop="position" label="部门职位"></el-table-column>
        <el-table-column prop="telephone" label="固定电话"></el-table-column>
        <el-table-column prop="fax" label="传真号码"></el-table-column>
        <el-table-column prop="sequence" label="排序"></el-table-column>
        <el-table-column prop="active" label="状态"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="componentSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      treeLoading: true,
      tableLoading: true,
      blockAddDepartment: false,
      blockEditDepartment: false,
      blockDeleteDepartment: false,
      blockBatchDeleteDepartment: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      componentSize: "",
      addFormDialogWidth: "",
      detailFormDialogWidth: "",
      editFormDialogWidth: "",
      addFormInline: false,
      detailFormInline: false,
      editFormInline: false,
      addFormTextareaStyle: "",
      detailFormTextareaStyle: "",
      editFormTextareaStyle: "",
      addFormVisible: false,
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: null,
        number: null,
        address: null
      },
      addForm: {
        parentId: null,
        name: null,
        number: null
      },
      addFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入父级id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "父级id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "部门名称长度在1到255个字"
          }
        ],
        number: [
          {
            required: true,
            message: "请输入部门编号",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "部门编号长度在1到255个字"
          }
        ]
      },
      detailForm: {
        parentId: null,
        name: null,
        number: null,
        address: null,
        position: null,
        telephone: null,
        fax: null,
        sequence: null
      },
      editForm: {
        parentId: null,
        name: null,
        number: null,
        address: null,
        position: null,
        telephone: null,
        fax: null,
        sequence: null
      },
      editFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入父级id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "父级id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "部门名称长度在1到255个字"
          }
        ],
        number: [
          {
            required: true,
            message: "请输入部门编号",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "部门编号长度在1到255个字"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入部门地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "部门地址长度在1到255个字"
          }
        ],
        position: [
          {
            required: true,
            message: "请输入部门职位",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "部门职位长度在1到255个字"
          }
        ],
        telephone: [
          {
            required: true,
            message: "请输入固定电话",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "固定电话长度在1到255个字"
          }
        ],
        fax: [
          {
            required: true,
            message: "请输入传真号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "传真号码长度在1到255个字"
          }
        ],
        sequence: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确"
          }
        ]
      },
      importForm: {},
      searchFormLabelWidth: "80px",
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      rangePickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/department/upload`,
      fileList: [],
      loading: false,
      permissions: [],
      filter: "",
      treeData: [],
      defaultProps: {
        children: "list",
        label: "name"
      }
    };
  },
  methods: {
    setComponentSize() {
      if (document.body.clientWidth <= 992) {
        this.componentSize = "mini";
        return;
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = "small";
        return;
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = "medium";
        return;
      }
    },
    setDialogWidth() {
      if (document.body.clientWidth > 1366) {
        this.addFormDialogWidth = "30%";
        this.addFormInline = false;
      } else {
        this.addFormDialogWidth = "40%";
        this.addFormInline = false;
      }
      if (document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = "30%";
        this.detailFormInline = false;
      } else {
        this.detailFormDialogWidth = "40%";
        this.detailFormInline = false;
      }
      if (document.body.clientWidth > 1366) {
        this.editFormDialogWidth = "45%";
        this.editFormInline = true;
        this.editFormTextareaStyle = "width:260%";
      } else {
        this.editFormDialogWidth = "60%";
        this.editFormInline = true;
        this.editFormTextareaStyle = "width:260%";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getDepartmentDetail() {
      this.api.department
        .getDepartment({
          id: this.selection
        })
        .then(result => {
          this.detailForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDepartment() {
      this.api.department
        .getDepartment({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.department
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addDepartment() {
      if (this.blockAddDepartment) {
        return false;
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.blockAddDepartment = true;
          this.api.department
            .addDepartment(this.addForm)
            .then(result => {
              this.addFormVisible = false;
              this.blockAddDepartment = false;
            })
            .catch(error => {
              this.blockAddDepartment = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateDepartment() {
      if (this.blockEditDepartment) {
        return false;
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.blockEditDepartment = true;
          this.api.department
            .updateDepartment(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockEditDepartment = false;
            })
            .catch(error => {
              this.blockEditDepartment = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteDepartment(row) {
      if (this.blockDeleteDepartment) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockDeleteDepartment = true;
          this.api.department
            .deleteDepartment([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockDeleteDepartment = false;
            })
            .catch(error => {
              this.blockDeleteDepartment = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteDepartment() {
      if (this.blockBatchDeleteDepartment) {
        return false;
      }
      if (this.ids.length === 0) {
        this.$message.error("请选择要删除的数据！");
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockBatchDeleteDepartment = true;
          this.api.department
            .deleteDepartment(this.ids)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockBatchDeleteDepartment = false;
            })
            .catch(error => {
              this.blockBatchDeleteDepartment = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.department
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.department
        .importData(this.importForm.rows)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.importFormVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDepartmentTree() {
      this.api.department
        .getDepartmentTree({})
        .then(result => {
          console.log(result)
          this.treeData = result.data;
          console.log(this.treeData)
          this.treeLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    nodeFilter(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    treeFilter: function() {
      this.$refs.tree.filter(this.filter);
    },
    handleNodeClick(data) {
      this.searchForm.parentId = data.id;
      this.addForm.parentId = data.id;
      this.editForm.parentId = data.id;
      if (!data.disabled) {
        this.pageList();
      }
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          if (a.url == this.$route.path) {
            a.resources.forEach(e => this.permissions.push(e.function));
          }
        });
      });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.getDepartmentTree();
        this.pageList();
      } else {
      }
    },
    detailFormVisible: function(newVal) {
      if (newVal) {
        this.getDepartmentDetail();
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.getDepartmentTree();
        this.pageList();
      } else {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".edit-form-dialog")
        });
        this.getDepartment();
        loading.close();
      }
    }
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.setComponentSize();
    this.setDialogWidth();
    this.getPermissionList();
    this.getDepartmentTree();
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/department/index.vue